
import './App.css';
import Organizer from './Organizer'
// import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Report from './reports/Report';
import ExternalShareHandler from './ExternalShare';

function App() {
  // console.log(items2)
  let url = window.location.protocol+"//python.bmhitechbricks.co.in/organizer";
  return (
     <BrowserRouter>
      <Routes>
      <Route path="/" >
          <Route index element={<Organizer contexturl={url}/>} />
          <Route path="reports" element={<Report />} />
          <Route path="share-handler"  element={<ExternalShareHandler contexturl={url} />} />

        </Route>
      </Routes>
      </BrowserRouter>
  // <TaskTable items={items2.tasks2}/>
  
  );
}
//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<App />);
export default App;
